import { useEffect } from 'react';
import './App.css';
import { Layout } from '../components/app/layout';
import { Start } from '../components/app/scene/Start';
import { useGameStore } from '../stores/gameStore';

export default function App() {
  const showGameStart = useGameStore((state) => state.showGameStart);
  const loggedIn = useGameStore((state) => state.loggedIn);
  const startGameTimer = useGameStore((state) => state.startGameTimer);
  const incrementGameTime = useGameStore((state) => state.incrementGameTime);

  // Start timer when user logs in
  useEffect(() => {
    startGameTimer();
  }, [startGameTimer]);

  // Increment game time every minute (every 60000ms, elapsed time advances by 5 minutes)
  useEffect(() => {
    if (!loggedIn) return;

    const interval = setInterval(() => {
      incrementGameTime();
    }, 60000); // Every 60 seconds

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [loggedIn, incrementGameTime]);

  return showGameStart ? <Start /> : <Layout />;
}
